import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AppContext from 'context/Context';
import AreaDropdown from 'components/dropdowns/AreaDropdown';
import { swalToastSuccess, swalToastError } from 'components/utilities/SwalToastUtil';
import { submitStockRequest } from 'services/stock-location/stockRequestService';
import LanguageSwitcher from '../LanguageSwitcher';
import NewStockRequestTable from './NewStockRequestTable';

const NewStockRequestModal = ({ isShow, handleClose, onSubmitted }) => {
  const {
    config: { isDark }
  } = useContext(AppContext);
  const { t } = useTranslation();

  const [area, setArea] = useState(null);
  const [rows, setRows] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isShow) {
      setArea(null);
      setRows([]);
    }
  }, [isShow]);

  const handleOrder = async () => {
    if (!rows.length) return;

    setIsSubmitting(true);
    try {
      const res = await submitStockRequest({
        areaId: area?.value,
        items: rows.map(row => ({
          productId: row.productId,
          emplasCode: row.emplasCode,
          supplierCode: row.supplierCode,
          description: row.description,
          qty: row.reqQty
        }))
      });

      if (!res?.success) {
        swalToastError(t('orderError'));
        return;
      }

      swalToastSuccess(t('orderSuccess'));
      onSubmitted?.();
      handleClose();
    } catch (err) {
      console.error(err);
      swalToastError(t('orderError'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={isShow}
      onHide={handleClose}
      size="xl"
      centered
      contentClassName="border"
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="bg-light border-bottom-0"
      >
        <Modal.Title>{t('modalTitle')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3 align-items-center">
          <Col>
            <LanguageSwitcher />
          </Col>
        </Row>

        <p>{t('modalInstruction')}</p>

        <Form.Group className="mb-3" style={{ maxWidth: 320 }}>
          <Form.Label>{t('modalArea')}</Form.Label>
          <AreaDropdown
            selectedOptions={area}
            handleChange={setArea}
            isMulti={false}
          />
        </Form.Group>

        <NewStockRequestTable
          area={area}
          rows={rows}
          setRows={setRows}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={handleOrder}
          disabled={isSubmitting || !area || rows.length === 0}
        >
          {isSubmitting ? t('orderSubmitting') : t('orderButton')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

NewStockRequestModal.propTypes = {
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  onSubmitted: PropTypes.func
};

export default NewStockRequestModal;
